import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PeopleIcon = (props: IconProps) => (
  <Icon width="25px" height="25px" viewBox="0 0 25 25" {...props}>
    <path d="M20.365 2.5H4.375c-1.1 0-2 .9-2 2l-.01 18 4-4h14c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2Zm0 14H5.535l-1.17 1.17V4.5h16v12Zm-8-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 0 0-5.56 0 2.01 2.01 0 0 0-1.22 1.85v.57h8v-.57Z" />
  </Icon>
);

export default memo(PeopleIcon);
